import { action } from 'easy-peasy';
import NavigationModel from './types/NavigationModel';
import { transition } from '../app/types';

const navigationModel: NavigationModel = {
  navigation: transition.reset([]),
  showNavigation: false,
  megaMenuOpened: false,

  toggleNavigation: action((state, payload) => {
    state.showNavigation = typeof payload === 'boolean' ? payload : !state.showNavigation;
  }),
  loadNavigation: action((state, payload) => {
    state.navigation = transition.loaded(payload);
  }),
  unloadNavigation: action(state => {
    state.navigation = transition.loaded([]);
  }),
  toggleMegaMenu: action((state, payload) => {
    state.megaMenuOpened = payload;
  }),
};

export default navigationModel;
